module.exports = __webpack_public_path__ + "static/media/ic-view-list.1b3fb661.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/ic-view-list.svg
// module id = 1364
// module chunks = 0